export const formatAccuracy = (accuracy: number): string =>
    `${(accuracy * 100).toFixed(2)}%`;

export const formatDuration = (duration: number): string =>
    `${duration?.toFixed(2)}s`;

export const getAccuracyColor = (accuracy: number): string => {
    if (accuracy >= 0.9) return "green";
    if (accuracy >= 0.7) return "yellow";
    return "red";
};
